<template>
  <div class="submission-bar">
    <div class="submission-container">
      <h4>Innlevering</h4>
      <div class="textarea-container">
        <textarea name="" id="" cols="30" rows="10"></textarea>
      </div>
      <form action="/action_page.php">
        <input type="file" id="myFile" name="filename" />
        <input type="submit" />
      </form>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.submission-container {
  display: flex;
  flex-direction: column;
  margin: auto;
  box-shadow: 0px 0px 7px 2px rgba(0, 0, 0, 0.46);
}
h4 {
  padding: 10px 0px 0px 10px;
}
.textarea-container {
  height: 40%;
  width: 95%;
  margin: auto;
  padding-bottom: 5px;
}
</style>